import { RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/document-lists",
    name: "document-lists",
    component: () => import("./pages/DocumentLists.vue"),
    meta: {
      requiresAuth: true,
      title: "documentLists.title",
      breadcrumb: [
        { label: "menu.dashboard", to: "/" },
        { label: "menu.document_lists" },
      ],
    },
  },
  {
    path: "/document-lists/:id",
    name: "document-lists-detail",
    component: () => import("./pages/DocumentListDetail.vue"),
    meta: {
      requiresAuth: true,
      title: "documentLists.detail",
      breadcrumb: [
        { label: "menu.dashboard", to: "/" },
        { label: "menu.document_lists", to: "/document-lists" },
        { label: "documentLists.detail_short" },
      ],
    },
  },
];

export default routes;
